import { NgModule } from '@angular/core';
import { ContactInfoFormModule } from 'app/components/contact-info/contact-info.module';
import { SharedModule } from 'app/shared/shared.module';
import { QuickCreateOrganizationComponent } from './quick-create-organization.component';

@NgModule({
    declarations: [
        QuickCreateOrganizationComponent,
    ],
    imports: [
        SharedModule,
        ContactInfoFormModule
    ],
    exports: [
        QuickCreateOrganizationComponent
    ]
})
export class QuickCreateOrganizationModule { }
